export default __webpack_public_path__ + "static/media/040_tunnel.hevc.bc8de3bf.mp4";